import { Drawer } from 'antd'
import ResultForm from './ResultForm'
import DrawerTitle from '../../../../shared/DrawerTitle'
import styles from '../../../../../testrun.module.css'

const AddResultDrawer = (props) => {
    const {
        stateTestRun = {},
        setStateTestRun = () => {},
        handleTestCaseList = () => {},
        selectedRowKeys = [],
        setSelectedRowKeys = () => {},
        reportId = '',
    } = props

    const isOpen = stateTestRun?.drawerEdit || false
    const isBulk = stateTestRun?.editType === 'bulk'
    const selectedCount = stateTestRun?.selectedTCID?.length || 0

    const handleClose = () => {
        setStateTestRun({ ...stateTestRun, drawerEdit: false })
    }

    const title = isBulk ? 'Bulk update results' : 'Add result'
    const subtitle = isBulk
        ? `${selectedCount} test case${selectedCount !== 1 ? 's' : ''} selected`
        : 'Record status, notes, and evidence for this run'

    return (
        <Drawer
            placement="right"
            width={520}
            rootClassName="testReportDrawer"
            closeIcon={null}
            open={isOpen}
            title={
                <div className={styles.resultDrawerHeader}>
                    <DrawerTitle title={title} onClose={handleClose} />
                    <p className={styles.resultDrawerSubtitle}>{subtitle}</p>
                </div>
            }
        >
            <ResultForm
                stateTestRun={stateTestRun}
                setStateTestRun={setStateTestRun}
                handleTestCaseList={handleTestCaseList}
                selectedRowKeys={selectedRowKeys}
                setSelectedRowKeys={setSelectedRowKeys}
                reportId={reportId}
            />
        </Drawer>
    )
}

export default AddResultDrawer
